module.exports = __webpack_public_path__ + "static/media/fly0014.f10a8a51.webp";